import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Status } from '@df/core/status';
import { Subscription } from 'rxjs';

@Component({
    selector: 'skeleton-loader',
    templateUrl: 'skeleton-loader.html',
    styleUrls: ['./skeleton-loader.scss'],
    standalone: true,
    imports: [NgTemplateOutlet],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkeletonLoaderComponent implements OnInit, OnChanges, OnDestroy {
    @Input()
    numberOfLines: number = 3;

    @Input()
    numberOfColumns: number = 4;

    @Input()
    height = '2em';

    @Input()
    status?: Status;

    @Input()
    variant: 'default' | 'media' = 'default';

    protected lines: number[] = [];
    protected squares: number[] = [];
    private statusSubscription?: Subscription;

    constructor(private changeDetectorRef: ChangeDetectorRef) {}

    ngOnInit() {
        switch (this.variant) {
            case 'default':
                this.lines = Array(this.numberOfLines).fill(0);
                break;
            case 'media':
                this.squares = Array(this.numberOfColumns * this.numberOfLines).fill(0);
                break;
        }
    }

    ngOnChanges(changes): void {
        if (changes['status']) {
            this.statusSubscription?.unsubscribe;
            this.statusSubscription = this.status?.subscribe(() => this.changeDetectorRef.detectChanges());
        }
    }

    ngOnDestroy(): void {
        this.statusSubscription?.unsubscribe;
    }
}
